// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"0e3024f7","938":"8c3b8e96"}[chunkId] + ".chunk.js";
};